import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../components/Spinner";

const EditAtleta = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [celular, setCelular] = useState("");
  const [perfil, setPerfil] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const token = localStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas/${id}`)
      .then((response) => {
        setNome(response.data.nome);
        setEmail(response.data.email);
        setPassword(response.data.password);
        setCelular(response.data.celular);
        setPerfil(response.data.perfil);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Erro ao consultar atletas. Check console");
      });
  }, [id]);

  const handleEditAtleta = () => {
    const data = { nome, email, password, celular, perfil };
    setLoading(true);
    axios
      // .put(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`, data, config)
      .put(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas/${id}`,
        data,
        config
      )
      .then(() => {
        setLoading(false);
        enqueueSnackbar("Dados da atleta atualizados.", { variant: "success" });
        navigate("/admin/atletas");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          enqueueSnackbar("Sessão expirada. Faça login novamente.", {
            variant: "warning",
          });
          navigate("/admin");
        } else {
          enqueueSnackbar("Não foi possível atualizar", { variant: "error" });
        }
        console.log(error);
      });
  };

  // const geraPassword = (e) => {
  //   setCelular(e.target.value);
  //   setPassword(nome.slice(0, 1).toUpperCase() + e.target.value.slice(-4));
  // };
  const handleCelularChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
    setCelular(numericValue);
    setPassword(nome.slice(0, 1).toUpperCase() + numericValue.slice(-4));
  };

  return (
    <div className="p-6 bg-base-100 flex justify-center items-center mt-16">
      {loading && <Spinner />}
      <div className="container max-w-lg shadow-lg rounded-lg p-5 bg-base-100">
        <h1 className="text-3xl font-semibold my-4">Editar atleta</h1>
        <div className="my-4">
          <label htmlFor="nome" className="block text-md  mb-2">
            Nome
          </label>
          <input
            id="nome"
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
            required
          />
          <label htmlFor="celular" className="block text-md  mb-2 mt-4">
            Celular
          </label>
          <input
            id="celular"
            type="number"
            value={celular}
            onChange={handleCelularChange}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="password" className="block text-md  mb-2 mt-4">
            Senha
          </label>
          <input
            id="password"
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
            required
          />

          <label htmlFor="perfil" className="block text-lg mb-2 mt-4">
            Perfil
          </label>
          <select
            id="perfil"
            // defaultValue="Atleta"
            value={perfil}
            onChange={(e) => setPerfil(e.target.value)}
            className="w-full border border-base-300 px-4 py-2 rounded-md"
            required
          >
            <option value="" disabled>
              Selecione o perfil
            </option>
            <option value="Atleta">Atleta</option>
            <option value="Assessoria">Assessoria</option>
          </select>

          <label htmlFor="email" className="block text-md  mb-2 mt-4">
            E-mail
          </label>

          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />
          <button
            onClick={handleEditAtleta}
            className="w-full bg-green-500
                              hover:bg-green-800 text-white py-2 px-4 rounded-md mt-4"
          >
            Salvar
          </button>
          <Link to="/admin/atletas" className="btn mt-5">
            Voltar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EditAtleta;
